import { render, staticRenderFns } from "./PublicClientForm.vue?vue&type=template&id=4c1fd482&scoped=true"
import script from "./PublicClientForm.vue?vue&type=script&lang=js"
export * from "./PublicClientForm.vue?vue&type=script&lang=js"
import style0 from "./PublicClientForm.vue?vue&type=style&index=0&id=4c1fd482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1fd482",
  null
  
)

export default component.exports